/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Caption_Lock_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Caption Lock" |
*
* @param {Player_Caption_Lock_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_caption_lock_aria_label = /** @type {((inputs?: Player_Caption_Lock_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Caption_Lock_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Verrouillage des Sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel-Sperre")
	if (locale === "it") return /** @type {LocalizedString} */ ("Blocco didascalia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Блокировка подписи")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bloqueo de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕锁定")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプションロック")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन लॉक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Bloqueio de legenda")
	return /** @type {LocalizedString} */ ("Caption Lock")
});